import http from '../adapters/http';

class GerenciadorDeTermos {
  async verificarSeUsuarioAceitouTermosEmVigor(login) {
    return http.post('/Administracao/GerenciadorDeTermos/VerificarSeUsuarioAceitouTermosEmVigor', { login }).then(res => res);
  }

  redirecionarParaOGerenciadorDeTermos(login) {
    const corpo = { login, returnUrl: location.host + location.pathname };
    http.post('/Administracao/GerenciadorDeTermos/ObterEnderecoDeAceitacaoDeTermo', corpo).then((response) => {
      window.location = response;
    });
  }
}

export default GerenciadorDeTermos;
